/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Gray_Hen_LimpInputs */

const en_green_gray_hen_limp = /** @type {(inputs: Green_Gray_Hen_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure segments, thresholds, and which results are visible.`)
};

const de_green_gray_hen_limp = /** @type {(inputs: Green_Gray_Hen_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie Segmente, Schwellenwerte und welche Ergebnisse sichtbar sind.`)
};

/**
* | output |
* | --- |
* | "Configure segments, thresholds, and which results are visible." |
*
* @param {Green_Gray_Hen_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_gray_hen_limp = /** @type {((inputs?: Green_Gray_Hen_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Gray_Hen_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_gray_hen_limp(inputs)
	return de_green_gray_hen_limp(inputs)
});